import i18next from 'i18next';

i18next.addResources('en', 'Products', {
  newProduct: 'Create a new product'
});
